var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0015 0L10.8344 4.16709V13.3347L15.0015 9.58432V0ZM16.6684 3.33368V14.5848C15.7516 14.2931 14.7515 14.1681 13.7514 14.1681C12.3346 14.1681 10.2927 14.7098 9.16761 15.4182V4.16709C7.95915 3.25033 6.20897 2.91697 4.5838 2.91697C2.95864 2.91697 1.20846 3.25033 0 4.16709V16.3767C0 16.585 0.208355 16.7934 0.416709 16.7934C0.500051 16.7934 0.541722 16.7517 0.625064 16.7517C1.75018 16.21 3.37535 15.835 4.5838 15.835C6.20897 15.835 7.95915 16.1683 9.16761 17.0851C10.2927 16.3767 12.3346 15.835 13.7514 15.835C15.1266 15.835 16.5434 16.085 17.7101 16.71C17.7935 16.7517 17.8352 16.7517 17.9185 16.7517C18.1269 16.7517 18.3352 16.5434 18.3352 16.335V4.16709C17.8352 3.79206 17.2934 3.54203 16.6684 3.33368ZM7.50077 14.5098C6.459 14.2431 5.41722 14.1681 4.5838 14.1681C3.70038 14.1681 2.65027 14.3265 1.66684 14.5848V5.10886C2.42525 4.77549 3.45035 4.5838 4.5838 4.5838C5.71725 4.5838 6.74236 4.77549 7.50077 5.10886V14.5098Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.1a355ebc7daabb78ead328cc70206354.svg";
export { ForwardRef as ReactComponent };